<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border" style="width:100%">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <!-- <b>{{ $t('newsManagement.categoriesObj.list') }}</b> -->
              <lte-button
                @click="callback()"
                style="float:right;background-color:white !important; margin-right: 50px"
                type="btn btn-default"
                right_icon="fa fa-plus"
                >{{ $t("user.createnew") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <b-table
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              :fields="gridColumns"
              :items="residentNewsList"
            >
              <template #head()="data">
                {{ $t(data.label) }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px"
                    @click="onEditNewsCategory(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    style="margin-left: 6px"
                    @click="onDeleteNewsCategory(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
      </row>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <div class="modal fade" id="modal-confirm-delete-catagory">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t('newsManagement.categoriesObj.confirmDeleteTitle') }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              @click="onConfirmDeleteNewsCategory()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t('common.delete_modal.btnYes') }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Paginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils'

export default {
  name: "UserGuestList",
  data() {
    return {
      residentNewsList: [],
      currentPage: 1,
      totalRows: 1,
      entryId: 0,
      user_guest_deleted_id: null,
      user_guest_last_name: "",
      perPage: 50,
      isLoading: false,
      user_guest_name: "",
      isModalVisible: false,
      gridColumns: [
        {
          key: "user_guest.nonumber",
          label: "user_guest.nonumber",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "title",
          label: "banner.title",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "actions",
          label: "mail_form.action",
          class: "text-center",
          tdClass: "stt"
        }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      actions: ["common.modify", "common.delete"],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      newsCategoryIdSelected: null,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      }
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATOR",
      "PAGINATION",
      "GET_ACCOUNT_DATA",
      "GET_NEWS_CATEGORY_LIST_DATA"
    ])
  },
  watch: {
    GET_NEWS_CATEGORY_LIST_DATA: function () {
      let paginate = this.GET_NEWS_CATEGORY_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_NEWS_CATEGORY_LIST_DATA.results;
      this.residentNewsList = []
      for (let i = 0, size = data.length; i < size; i++) {
        let nonumber =
          i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let object = {
          "id": data[i].id,
          "user_guest.nonumber": nonumber,
          "title": data[i].title
        };
        this.residentNewsList.push(object);
      }
    }
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_NEWS_CATEGORY_LIST",
      "DELETE_NEWS_CATEGORY"
    ]),
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    /**
     * Edit banner
     */
    onEditNewsCategory: function (id) {
      this.$router.push({
        name: "NewsCategoriesUpdate",
        params: {
          id: id
        }
      });
    },
    /**
     * Confirm delete banner
     */
    onConfirmDeleteNewsCategory: function () {
      this.DELETE_NEWS_CATEGORY({id: this.newsCategoryIdSelected}).then(
        function () {
          this.SUCCESS_TOAST();
          $("#modal-confirm-delete-catagory").modal("hide");
          this.getNewsCategoryList(this.paginateData.currentPage)
        }.bind(this)
      ).catch(
        function () {
          this.ERROR_TOAST();
        }.bind(this)
      )
    },
    /**
     * Edit banner
     */
    onDeleteNewsCategory: function (id) {
      this.newsCategoryIdSelected = id
      $("#modal-confirm-delete-catagory").modal("show");
    },
    callback: function() {
      this.$router.push({
        name: "NewsCategoriesAdd",
        params: {
          id: 0
        }
      });
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data
      this.getNewsCategoryList(data)
    },
    /**
     * Get banner list
     */
    getNewsCategoryList: function (page) {
      const data = {
        params: {
          page: page
        }
      };
      this.isLoading = true
      this.GET_NEWS_CATEGORY_LIST(data).then(
        function () {
          this.isLoading = false
        }.bind(this)
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    }
  },
  mounted() {
    this.getNewsCategoryList(1)
  },
  components: {
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading
  }
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) { 
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsCategoryList.vue